
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M12.942 15.442a.625.625 0 01-.884 0l-5-5a.625.625 0 010-.884l5-5a.625.625 0 11.884.884L8.384 10l4.558 4.558a.625.625 0 010 .884z"}})])
          )
        }
      }
    